import { Type } from 'class-transformer'
import { RoomRule } from './Calendar/RoomRule'

export class Calendar {

  public readonly url: string

  @Type(() => RoomRule)
  public readonly roomRules: RoomRule[]

  constructor(url: string, roomRules: RoomRule[]) {
    this.url = url
    this.roomRules = roomRules
  }
}
